import React, { FC, useEffect, useRef, useState } from 'react';
import MainBox from 'src/components/molecules/contentLayout/MainBox';
import TitleContent from 'src/components/molecules/contentLayout/TitleContent';
import { homeTaxData } from 'src/static/sample/stepC';
import { initDataStore } from 'src/store/taxData';
import { creditcardDataStore } from 'src/store/creditcard';
import {
  settlementNtsDataStore,
  ntsFileDataStore,
  settlementDataStore,
} from 'src/store/settlementInfo';
import HomeTaxPDF from './HomeTaxPdf';
import HomeTaxInsert from './HomeTaxInsert';
import HomeTaxData from './HomeTaxData';
import './style.scss';

interface Props {
  num: number;
}

const StepC: FC<Props> = ({ num }) => {
  const initDataState = initDataStore(state => state.result);
  const creditcardDataState = creditcardDataStore(state => state.result)?.data || {};
  const confirmEvt = () => {
    console.log('CONFIRM!');
  };
  const pdfData = initDataState.data?.pdfList || [];
  // NTS 업로드파일 데이터
  const ntsFileData = ntsFileDataStore((state: any) => state.result)?.data || [];

  const viewType = true;

  const middleContent = () => {
    return (
      <div className="_temp_content_layout _temp_step_c_layout">
        <div className="_info_step">
          <section className="_section_layout _t2">
            <TitleContent
              label="국세청 자료 입력"
              content={<HomeTaxInsert data={pdfData} />}
              foldBtn={true}
              contentView={viewType}
            />
          </section>
          {ntsFileData.length > 0 ? (
            <section className="_section_layout _t2">
              <TitleContent
                label="국세청 PDF 파일 목록"
                content={<HomeTaxPDF data={pdfData} />}
                foldBtn={true}
                contentView={true}
              />
            </section>
          ) : (
            ''
          )}
          <section className={`_section_layout _tax_list _active`}>
            <TitleContent label="" content={<HomeTaxData />} />
          </section>
        </div>
      </div>
    );
  };
  return (
    <div className="_step_layout">
      <MainBox
        label="연말정산 입력"
        content={middleContent()}
        num={num}
        icon="ri-file-edit-line"
        desc=<div>
          입력한 정보는 연말정산 세액 계산의 근거가 됩니다.
          <br /> 허위 또는 부정확한 정보를 입력한 경우 공제가 배제되거나 추후 세액이 추징될 수
          있으니, 관련 법령에 따른 공제 요건을 확인한 후 정확하게 입력해 주시기 바랍니다.
        </div>
        confitmEvent={confirmEvt}
        viewType="slide"
      />
    </div>
  );
};

export default StepC;
